<template>
  <div class="mob-bar">
    <div class="section-frame">
      <ul class="mob-bottom-link">
        <li>
          <router-link to="/">
            <i class="fa-home"></i>
            <p>{{ $t("home") }}</p>
          </router-link>
        </li>
        <li>
          <router-link to="/courses" class="js-popup-courses">
            <i class="fa-list"></i>
            <p>{{ $t("courses") }}</p>
          </router-link>
        </li>
        <li>
          <router-link to="/cart">
            <i class="fa-cart"></i>
            <p>{{ $t("cart") }}</p>
          </router-link>
        </li>
        <li
          v-if="token && user"
          @click.prevent="$emit('active', (active = true))"
        >
          <a href="#" class="js-popup-user user-menu" style="margin-top: 0">
            <span
              class="user-notification"
              style="right: 0px"
              v-if="notification && notification_count"
              >{{ notification_count }}</span
            >
            <i class="fa-user"></i>
            <p>{{ $t("profile") }}</p>

            <svg
              class="invalid"
              v-if="
                user.first_name === '' ||
                user.last_name === '' ||
                user.full_name === '' ||
                user.date_birth === '' ||
                user.login === '' ||
                user.city === ''
              "
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 192 512"
            >
              <path
                fill="currentColor"
                d="M20 424.229h20V279.771H20c-11.046 0-20-8.954-20-20V212c0-11.046 8.954-20 20-20h112c11.046 0 20 8.954 20 20v212.229h20c11.046 0 20 8.954 20 20V492c0 11.046-8.954 20-20 20H20c-11.046 0-20-8.954-20-20v-47.771c0-11.046 8.954-20 20-20zM96 0C56.235 0 24 32.235 24 72s32.235 72 72 72 72-32.235 72-72S135.764 0 96 0z"
              ></path>
            </svg>
          </a>
        </li>
        <li v-else>
          <router-link to="/login" class="js-popup-user">
            <i class="fa-out"></i>
            <p>{{ $t("login") }}</p>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: false,
      token: !!localStorage.getItem("access"),
    };
  },
  mounted() {},
  computed: {
    user() {
      return this.$store.getters.getUserCredentials;
    },
    notification() {
      return this.$store.getters.getNotifications;
    },
    notification_count() {
      if (!this.notification) return 0;
      return this.notification.filter((e) => !e.show_status).length;
    },
  },
};
</script>
